import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import ExportCsvButton from "../components/ExportCsvButton";

const TIER_LABEL = {
  merchant_lite: "Merchant Lite",
  social_vendor_pro: "Social Vendor Pro",
  enterprise_sme: "Enterprise SME",
};

const STATUS_BADGE = {
  active: "badge-active", cooling_off: "badge-cooling", pending: "badge-pending",
  suspended: "badge-suspended", cancelled: "badge-rejected", expired: "badge-rejected",
  claim_locked: "badge-review",
};

export default function Policies() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/policies").then((r) => {
      // Backend returns {policies: [...], count} (wrapped)
      const list = Array.isArray(r.data) ? r.data : (r.data?.policies || []);
      setItems(list);
    });
  }, []);

  return (
    <div className="p-8 space-y-6" data-testid="policies-page">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#c15337]">{t("admin_pages.policies_section")}</div>
          <h1 className="font-heading text-3xl font-bold mt-1 text-[#114232]">{t("admin_pages.policies_title")}</h1>
        </div>
        <ExportCsvButton path="/admin/exports/policies.csv" filename="policies" testid="export-policies-csv" />
      </header>

      <div className="bg-white border border-border rounded-md overflow-x-auto">
        <table className="w-full text-sm" data-testid="policies-table">
          <thead className="text-xs uppercase tracking-wider text-stone-500">
            <tr>
              <th className="text-left font-medium py-3 px-5">Policy #</th>
              <th className="text-left font-medium py-3 px-5">Tier</th>
              <th className="text-left font-medium py-3 px-5">Premium</th>
              <th className="text-left font-medium py-3 px-5">Cover</th>
              <th className="text-left font-medium py-3 px-5">Cooling-off ends</th>
              <th className="text-left font-medium py-3 px-5">KFS</th>
              <th className="text-left font-medium py-3 px-5">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-border table-row-hover" data-testid={`policy-row-${p.id}`}>
                <td className="py-3 px-5 font-mono text-xs">{p.policy_number}</td>
                <td className="py-3 px-5">{TIER_LABEL[p.tier_code] || p.tier}</td>
                <td className="py-3 px-5 font-mono">KES {p.weekly_premium ?? p.premium_amount}/wk</td>
                <td className="py-3 px-5 font-mono">KES {p.cover_limit.toLocaleString()}</td>
                <td className="py-3 px-5 text-xs text-muted-foreground">
                  {p.cooling_off_end_date ? new Date(p.cooling_off_end_date).toLocaleDateString() : "—"}
                </td>
                <td className="py-3 px-5">
                  <span className={`badge-status ${p.kfs_acknowledged ? "badge-success" : "badge-pending"}`}>
                    {p.kfs_acknowledged ? `Ack (${p.kfs_language || "en"})` : "Pending"}
                  </span>
                </td>
                <td className="py-3 px-5">
                  <span className={`badge-status ${STATUS_BADGE[p.status] || "badge-pending"}`}>
                    {p.status.replace(/_/g, " ")}
                  </span>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={7} className="py-10 text-center text-muted-foreground">No policies found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
